<template>

    <div class="assetsContainer">

        <div v-for="(asset, index) in assets" :key="asset.id" :class="[{'isDefault': asset.isDefault==true}, 'asset']">

            <div class="dragHandler" title="verschieben">
                <span class="icon is-small">
                    <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                </span>
            </div>

            <pop-confirm v-if="!isReadOnly" :content="$t('CONFIRMATION-DELETE_ASSET')" icon="question-circle-o" cancel-text="abbrechen" :on-ok="function() { removeAsset(index) }">
                <button class="delete button is-single is-small is-danger" title="löschen">
                    <!-- <span class="icon is-small"><i class="fa fa-trash-o"></i></span> -->
                </button>
            </pop-confirm>


            <div class="imgContainer">

                <div v-lazy:background-image="getAsset(asset.asset)">

                </div>

            </div>


            <div class="assetFooter">

                <tooltip :content="asset.isDefault == true ? 'Dieses Bild ist als Standard ausgewählt' : 'Dieses Bild als Standard auswählen'">
                    <a class="defaultAssetButton" @click="setIsDefault(index)">
                        <span class="icon is-small">
                            <i :class="['fa', asset.isDefault ? 'fa-check-square-o' : 'fa-square-o']"></i>
                        </span>
                    </a>
                </tooltip>

                <tooltip :content='`Download "` + getAssetDownloadFilename(asset.asset) +`"`'>
                    <a :href="getAssetDownloadLink(asset.asset)" :download="getAssetDownloadFilename(asset.asset)" class="downloadLink" title="download">
                        <span class="icon is-small">
                            <i class="fa icon-ak-download"></i>
                        </span>
                    </a>
                </tooltip>

            </div>

        </div>

    </div>

</template>


<script>


export default {

    data() {
		return {

        }
    },

    props: {
        assets: {
            type: Array,
            default: []
        }
    },

    components: {

    },

    computed: {

    },

    methods: {

        setIsDefault(index) {

            var self = this;
            this.assets.forEach(function(asset, i) {
                self.$set(self.assets[i], 'isDefault', false);
                // asset.isDefault = false;
            })

            // this.assets[index].isDefault = true;
            this.$set(this.assets[index], 'isDefault', true);
            this.$emit('setDefaultAsset', this.assets[index]);

        },

        getAsset(asset) {

            let url = asset.filename;

            // get file extension
            let ext = (url.split('.').pop()).toLowerCase();

            // check if we've an image
            if(ext == 'jpg' || ext == 'jpeg' || ext == 'gif' || ext == 'png') {
                return this.$config.assets + asset.path + '/' + asset.filename;
            }

            // otherwise we display a predefined icon
            let extensions = ['ai', 'eps', 'indd', 'pdf', 'psd', 'tiff', 'tif', 'doc', 'docx', 'xls', 'xlsx'];

            if(extensions.indexOf(ext) > -1) {
                return require('../../assets/img/fileTypes/datei-'+ext+'.png');
            } else {
                return require('../../assets/img/fileTypes/datei-undefined.png');
            }

        },

        getAssetDownloadLink(asset) {
            return this.$config.assets + asset.path + '/' + asset.filename;
        },

        getAssetDownloadFilename(asset) {
            return asset.uploadFilename != null ? asset.uploadFilename : asset.filename;
        },


        dragEnd() {

            this.resortAssets();
            this.$emit('update', this.assets);

        },

        removeAsset(index) {

            this.assets.splice(index,1);
            this.resortAssets();
            // this.$emit('update', this.assets);
            // this.$emit('removeAsset', index);
        },

        resortAssets() {
            return;
            for(var i=0; i < this.assets.length; i++) {
                this.assets[i].sortorder = i;
            }
        }

    }

}
</script>


<style scoped>

    .assetFooter {
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #e3e3e3;
        width: 100%;
        padding: 0;
        margin: 0;
    }
    .assetFooter a {
        background: none;
        color: #aaa;
        border: none !important;
        transition: all .3s ease;
        padding: 6px;
    }
    .assetFooter a:hover {
        text-decoration: none;
        border: none;
        color: #444;
    }

    .isDefault .defaultAssetButton {
        color: #000;
    }


    .assetsContainer {
        width: 100%;
        border: none !important;
        margin: 0 0 25px 0 !important;
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        justify-content: flex-start;
    }
    .assetsContainer .asset {
        position: relative;
        background: #ddd;
        padding: 0;
        border: 1px solid #e9e9e9;
        border-radius: 2px;
        /*transition: border-color .2s ease;*/
        overflow: hidden;
        flex-direction: row;
        flex-basis: 32.5%;
        min-width: 32.5%;
        margin: 0 1.25% 10px 0;
        transition: all .3s ease;
    }
    .assetsContainer .asset:nth-child(3n+0) {
        margin-right: 0;
    }
    .assetsContainer .asset.isDefault {
        border: 1px solid #000;
    }
    .assetsContainer .asset:hover {
        border: 1px solid #aaa;
    }
    .assetsContainer .asset .imgContainer {
        width: 100%;
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #f5f5f5;
        padding: 5px;
    }
    .assetsContainer .asset .imgContainer > div {
        background-repeat: no-repeat;
        background-position: center;
        width: 100%;
        height: 100%;
    }
    .assetsContainer .asset .imgContainer > div[lazy=loading] {
        background-size: 20%;
    }
    .assetsContainer .asset .imgContainer > div[lazy=loaded] {
        background-size: contain;
        -webkit-animation-duration: 1s;
        animation-duration: 1s;
        -webkit-animation-fill-mode: both;
        animation-fill-mode: both;
        -webkit-animation-name: fadeIn;
        animation-name: fadeIn;
    }

    /* delete button */
    .assetsContainer .button.delete {
    	position: absolute;
    	z-index: 99;
    	right: 0;
    	top: 0;
    	opacity: 0;
    	transition: all .3s ease;
        border-radius: 0 !important;
        border-bottom-left-radius: 2px !important;
    }
    .assetsContainer .asset:hover .button.delete {
    	opacity: 1;
    }
    .assetsContainer .asset .button.delete .icon {
    	margin: 0 auto !important;
        width: 14px;
        height: 14px;
        line-height: 14px;
    }
    .assetsContainer .asset .button.delete i {
    	font-size: 10px;
    }

    /* drag handler */
    .asset .dragHandler {
        display: none;
        position: absolute;
        z-index: 9999;
        left: 0;
        top: 0;
        width: 20px;
        height: 20px;
        line-height: 20px;
        background: #f1f1f1;
        cursor: grabbing;
        vertical-align: middle;
        text-align: center;
        transition: all .2s ease;
        border-bottom-right-radius: 2px;
        opacity: 0;
    	transition: all .3s ease;
    }
    .asset:hover .dragHandler {
        opacity: 1;
    }
    .asset .dragHandler .icon {
        vertical-align: middle;
        color: #bbb;
        transition: color .2s ease;
    }
    .asset .dragHandler:hover {
        background-color: #ddd;
    }
    .asset .dragHandler:hover .icon {
        color: #000;
    }


    /* download button */
    /*
    .assetsContainer .downloadLink {
        display: block;
        text-align: center;
        transition: background .3s ease;
        height: auto !important;
        padding: 0 !important;
        border: none;
    }
    .assetsContainer .downloadLink:hover {
        background-color: #eee;
        border: none;
    }
    .assetsContainer .downloadLink:hover .icon i {
        color: #222;
    }
    .assetsContainer .downloadLink .icon {
        display: inline-block;
        margin: 5px auto !important;
        vertical-align: middle;
        height: auto;
    }
    .assetsContainer .downloadLink .icon i {
        color: #aaa;
        transition: color .5s ease;
    }
    */


    /* selector */
    .assetTypeSelector {
        margin: 5px auto;
        text-align: center;
    }
    .assetTypeSelector .select {
        margin: 0 auto;
        max-width: 120px;
    }
    .assetTypeSelector select option {
        padding: 10px !important;
        margin: 10px !important;
    }

    .assetTypeSelector .control.has-addons {
        justify-content: center;
    }
    .assetTypeSelector .button {
        font-size: 8px;
        height: 20px;
        line-height: 20px;
        border: 1px solid transparent !important;
        transition: all .2s ease;
    }
    .assetTypeSelector .button:hover {
        font-size: 8px;
        height: 20px;
        line-height: 20px;
        border: 1px solid transparent !important;
        background-color: #888;
        color: #fff;
        /*rborder: 1px solid white !important;*/
    }
    .assetTypeSelector .button.is-primary {
        font-size: 8px;
        height: 20px;
        line-height: 20px;
        border: 1px solid transparent !important;
        background-color: #444;
        color: #fff;
    }



    /* @media queries */
    /*
    @media screen and (max-width: 1280px) {

        .assetsContainer .asset {
            max-width: 24%;
        }

    }

    @media screen and (max-width: 1024px) {

        .assetsContainer .asset {
            max-width: 33%;
        }

    }

    @media screen and (max-width: 780px) {

        .assetsContainer .asset {
            max-width: 49%;
        }

    }
    */

</style>
